import moment from "moment";
import _ from "lodash";

import {BACKEND_DATE_FORMAT} from "../../../utils/utils";

export const choiceValue = (value) => value ? String(value) : null;

export const dateToMoment = (value) => value ? moment(value) : null;

export const momentToDate = (value) => value && value.format(BACKEND_DATE_FORMAT);

export const calculateAssetsPayment = (periodDays=0, startDate, endDate, rateValue, assetValue) => {
  const totalDays = endDate.diff(startDate, 'days');
  const fullPeriods = periodDays ? Math.trunc(totalDays / periodDays) : 0;
  const remainingDays = totalDays - (fullPeriods * periodDays);
  const rate = rateValue / 100;

  const interestForFullPeriods = assetValue * rate * (periodDays / 360) * fullPeriods;
  const interestForRemainingDays = assetValue * rate * (remainingDays / 360);

  return _.round(interestForFullPeriods + interestForRemainingDays, 2);
};

export const getCalculationDisabledReason = (fieldNames) => {
  const joinedFields = _.join(fieldNames.map(f => `“${f}”`), ', ');

  return `Für die automatische Berechnungen müssen die Felder ${joinedFields} befüllt sein.`
};